@if (allowPricingLink) {
  <a
    class="pro-tag {{ productName() }}"
    [class.center]="center"
    [class.small]="small"
    [class.no-top]="noTop"
    [routerLink]="
      productName() === 'enterprise' ? '/enterprise' : canStartTrial() ? '/a/checkout/' + productName() : '/a/pricing'
    "
    [queryParams]="
      productName() === 'enterprise' ? undefined : canStartTrial() ? undefined : { product: productName() }
    "
    [appTooltip]="text"
    [skipDelay]="true"
    appClickTrack
    name="pro-tag"
    [location]="location"
    (click)="closeDialogs()"
  >
    <div class="pro-tag-inner">
      <app-svg src="/assets/icons/sparks.svg" size="-1"></app-svg>
      @if (!small) {
        <span>{{ productName() | productNameShort | uppercase }}</span>
      }
    </div>
  </a>
} @else {
  <div
    class="pro-tag {{ productName() }}"
    [class.center]="center"
    [class.small]="small"
    [class.no-top]="noTop"
    [appTooltip]="'Ask an admin to upgrade to use this feature'"
    [skipDelay]="true"
  >
    <div class="pro-tag-inner">
      <app-svg src="/assets/icons/sparks.svg" size="-1"></app-svg>
      @if (!small) {
        <span>{{ productName() | productNameShort | uppercase }}</span>
      }
    </div>
  </div>
}
